<template>
  <div class="container">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/termometria' }">Orçamentos Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Novo</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <h2 v-if="orcamento.tipo_termometria==1">Novo Orçamento Termometria com Controle de Aeração</h2>
      <h2 v-if="orcamento.tipo_termometria==0">Novo Orçamento Termometria</h2>

      <el-row>
        <el-col :span="24" align="right">Orçamento <strong>{{ orcamento.orcamento_base }}.{{ orcamento.orcamento_versao }}</strong></el-col>
      </el-row>
      <el-row>
        <el-col :span="24" align="right" v-if="orcamento.validade">Validade <strong>{{ orcamento.validade }}</strong></el-col>
      </el-row>
      <el-row>
        <el-col :span="24"><span align="left" style="font-size: 14px;">Representante <br/> <strong>{{ representante.nome }}</strong></span> </el-col>
      </el-row>

      <el-form :model="orcamento" ref="formOrcamento" @submit.native.prevent="submitOrcamento">

        <!-- Histórico da Revisão -->
        <el-row>
          <el-form-item label="Histórico da Revisão" prop="orcamento_base">
            <el-input v-model="orcamento.orcamento_historico_revisao" maxlength="60" required></el-input>
          </el-form-item>
        </el-row>

        <!-- Seleção de Lista de Produtos -->
        <el-form-item label="Lista de Preço de Produtos" prop="produto_lista_id" :rules="{ required: true, message: 'Selecione uma lista de produtos', trigger: 'change' }">
          <br />
          <el-select 
            v-model="orcamento.produto_lista_id" 
            placeholder="Selecione uma lista de produtos" 
            @change="buscarPrecos" 
            clearable 
            filterable 
            class="select-data"
          >
            <el-option 
              v-for="lista in listas" 
              :key="lista.id" 
              :label="`${lista.nome} - Ini (${lista.data_inicio}) - Fim (${lista.data_fim}) - Val (${lista.data_validade})`"
              :value="lista.id" 
            />
          </el-select>
        </el-form-item>

        <!-- Seleção de Vendedor -->
        <el-row v-if="edicaoOrcamento">
          <el-col :span="24">
            <el-form-item label="Vendedor" prop="users_id" :rules="{ required: true, message: 'Selecione um vendedor', trigger: 'change' }">
              <br />
              <el-select 
                v-model="orcamento.users_id" 
                filterable 
                placeholder="Selecione um vendedor" 
                :disabled="true"
                clearable 
                class="select-data"
              >
                <el-option 
                  v-for="vendedor in vendedores" 
                  :key="vendedor.id" 
                  :label="vendedor.nome" 
                  :value="vendedor.id" 
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Seleção de Contato -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="Contato" prop="contato_id" :rules="{ required: true, message: 'Selecione um contato', trigger: 'change' }">
              <br />
              <el-select 
                v-model="orcamento.contato_id" 
                filterable 
                placeholder="Selecione um contato" 
                :disabled="edicaoOrcamento"
                clearable 
                class="select-data"
              >
                <el-option 
                  v-for="contato in contatos" 
                  :key="contato.id" 
                  :label="contato.nome" 
                  :value="contato.id" 
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button 
              :disabled="orcamento.contato_id === null || edicaoOrcamento" 
              style="margin-top: 40px; margin-left: 10px;" 
              plain 
              @click="editarContato(orcamento.contato_id)"
              title="Editar o contato"
            >
              Editar
            </el-button>
            <el-button 
              :disabled="edicaoOrcamento"
              style="margin-top: 40px; margin-left: 10px;" 
              type="primary" plain 
              @click="adicionarContato"
              title="Adicionar um contato"
            >
              Adicionar
            </el-button>
          </el-col>
        </el-row>

        <!-- Seleção de Cliente -->
        <el-row>
          <el-col :span="20">
            <el-form-item label="Cliente Final" prop="cliente_id" :rules="{ required: true, message: 'Selecione um cliente final', trigger: 'change' }">
              <br />
              <el-select 
                v-model="orcamento.cliente_id" 
                filterable 
                placeholder="Selecione um cliente final" 
                @change="mostrarDadosCliente" 
                :disabled="edicaoOrcamento"
                clearable 
                class="select-data"
              >
                <el-option 
                  v-for="cliente in clientes" 
                  :key="cliente.id" 
                  :label="cliente.nome" 
                  :value="cliente.id" 
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button 
              :disabled="orcamento.cliente_id === null || edicaoOrcamento" 
              style="margin-top: 40px; margin-left: 10px;" 
              plain 
              @click="editarCliente(orcamento.cliente_id)"
              title="Editar o cliente"
            >
              Editar
            </el-button>
            <el-button 
              :disabled="edicaoOrcamento"
              style="margin-top: 40px; margin-left: 10px;" 
              type="primary" plain 
              @click="adicionarCliente"
              title="Adicionar um cliente"
            >
              Adicionar
            </el-button>
          </el-col>
        </el-row>

        <!-- Dados do Cliente -->
        <div v-if="clienteSelecionado" class="cliente-info">
          <el-row style="font-size: 14px;">
            <el-col :span="12">
              <table>
                <tr>
                  <td style="text-align: right;"><span v-if="clienteSelecionado.logradouro">Logradouro:</span></td><td><strong>{{ clienteSelecionado.logradouro }}</strong></td>
                </tr>
                <tr>
                  <td style="text-align: right;"><span v-if="clienteSelecionado.bairro">Bairro:</span></td><td><strong>{{ clienteSelecionado.bairro }}</strong></td>
                </tr>
                <tr>
                  <td style="text-align: right;"><span v-if="clienteSelecionado.cidade || clienteSelecionado.estado || clienteSelecionado.cep ">Cidade:</span></td><td><strong>{{ clienteSelecionado.cidade }} <span v-if="clienteSelecionado.cidade">-</span> {{ clienteSelecionado.estado }} <span v-if="clienteSelecionado.estado && clienteSelecionado.cep">-</span> {{ clienteSelecionado.cep }}</strong></td>
                </tr>
              </table>
            </el-col>
            <el-col :span="12">
              <table>
                <tr>
                  <td style="text-align: right;"><span v-if="clienteSelecionado.cpfcnpj">CPF/CNPJ:</span></td><td><strong>{{ clienteSelecionado.cpfcnpj }}</strong></td>
                </tr>
                <tr>
                  <td style="text-align: right;"><span v-if="clienteSelecionado.email">Telefone:</span></td><td><strong>{{ clienteSelecionado.telefone }}</strong></td>
                </tr>
                <tr>
                  <td style="text-align: right;"><span v-if="clienteSelecionado.email">Email:</span></td><td><strong>{{ clienteSelecionado.email }}</strong></td>
                </tr>
              </table>
            </el-col>
          </el-row>
        </div>

        <el-checkbox v-model="orcamento.ampliacao" label="Ampliação" @change="calcularTotais"/>

        <!-- Itens do Orçamento -->
        <div class="itens">
          <h3>Produtos</h3>
          <el-table v-if="produtos.length > 0" :data="orcamento.itens" border style="width: 100%">
            <el-table-column label="Produto" prop="produto_id" min-width="530">
              <template slot-scope="scope">
                <el-select
                  :disabled="(scope.row.produto_id === centralTermoB || 
                              scope.row.produto_id === estacaoMetereologica || 
                              scope.row.produto_id === mav4A || 
                              scope.row.produto_id === mav8A) && !orcamento.ampliacao"
                  v-model="scope.row.produto_id"
                  placeholder="Selecione um produto"
                  @change="updatePreco(scope.$index)"
                  clearable
                  filterable
                  class="select-data"
                >
                  <el-option
                    v-for="produto in produtos"
                    :key="produto.id"
                    :label="`${produto.nome}`"
                    :value="produto.id"
                  />
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="NBRtec" prop="cod_nbr" min-width="80">
            </el-table-column>
            <el-table-column label="Fabricante" prop="cod_fabricante" min-width="130">
            </el-table-column>
            <el-table-column label="Quantidade" prop="quantidade" width="160" align="right" header-align="center">
              <template slot-scope="scope">
                <el-input-number
                  :disabled="(scope.row.produto_id === centralTermoB || 
                              scope.row.produto_id === estacaoMetereologica || 
                              scope.row.produto_id === mav4A || 
                              scope.row.produto_id === mav8A) && !orcamento.ampliacao"
                  v-model="scope.row.quantidade"
                  :min="1"
                  :step="1"
                  :precision="0"
                  @change="calcularTotais"
                  class="small-input-number"
                />
              </template>
            </el-table-column>
            <el-table-column label="Preço" prop="preco" width="120" align="right" header-align="right">
              <template slot-scope="scope">
                {{ scope.row.preco | currency }}
              </template>
            </el-table-column>
            <el-table-column label="Subtotal" width="120" align="right" header-align="right">
              <template slot-scope="scope">
                {{ (scope.row.quantidade * scope.row.preco) | currency }}
              </template>
            </el-table-column>
            <el-table-column label="Ação" width="110">
              <template slot-scope="scope">
                <el-button 
                  :disabled="(scope.row.produto_id === centralTermoB || 
                              scope.row.produto_id === estacaoMetereologica || 
                              scope.row.produto_id === mav4A || 
                              scope.row.produto_id === mav8A) && !orcamento.ampliacao"
                  type="danger" 
                  size="small" 
                  @click="removeItem(scope.$index)"
                >Remover</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-row>
            <br/>
            <el-col :span="10"> 
              <el-button type="primary" plain @click="addItem">Adicionar Produto</el-button>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="5">
              <!-- Ventiladores -->
              <el-form-item v-if="!orcamento.ampliacao" label="Ventiladores" prop="ventiladores">
                <br />
                <el-input-number  
                  v-model="orcamento.ventiladores"
                  :min="0"
                  :step="1"
                  @change="calcularTotais"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- Totais -->
        <div class="totais">
          <el-row>
            <el-col :span="20" align="right">Total sem IPI: </el-col>
            <el-col :span="4" align="right"><strong>{{ orcamento.total_sem_ipi | currency }}</strong></el-col>
          </el-row>
          <el-row>
            <el-col :span="20" align="right">IPI ({{orcamento.aliquota_ipi_reduzida*100}}%): </el-col>
            <el-col :span="4" align="right"><strong>{{ orcamento.ipi | currency }}</strong></el-col>
          </el-row>
          <el-row>
            <el-col :span="20" align="right">Total com IPI: </el-col>
            <el-col :span="4" align="right"><strong>{{ orcamento.total_com_ipi | currency }}</strong></el-col>
          </el-row>
        </div>
        <br />

        <div>
          <el-row>
            <el-col :span="24">
              <p><strong>Observação:</strong></p>
              <el-form-item label="" prop="observacao">
                <el-input type="textarea" v-model="orcamento.observacao" :autosize="{ minRows: 2, maxRows: 10}"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="observacoes">
          <el-row>
            <el-col :span="24">
              <p><strong>Observações:</strong></p>
              <span v-if="orcamento.ventiladores_possiveis>0">– O total de motores possíveis é de até {{ orcamento.ventiladores_possiveis }} motores;</span><br/>
              <span>– Valores sem mão de obra para instalação, caso necessário deverá ser cotado a parte;</span><br/>
              <span>– Frete na modalidade FOB-PANAMBI/RS;</span><br/>
              <span v-if="orcamento.reducao_ipi>0">– Redução da aliquota de IPI em {{ orcamento.reducao_ipi*100 }}%;</span>
            </el-col>
          </el-row>
        </div>
        <br />
        <br />

        <!-- Botão de Envio -->
        <el-form-item>
          <el-button type="primary" native-type="submit">Salvar Orçamento</el-button>
<!-- 
          <el-button type="success" @click="gerarRelatorioLatex">Gerar Relatório LaTeX</el-button>
-->
        </el-form-item>
      </el-form>
    </el-row>

    <el-dialog title="Aviso Importante" 
      style="text-align: center;" 
      :visible="formAvisoVisible"
      :close-on-click-modal="false"
    >
      <ul style="text-align: left;">
        <li>Definir o modelo do silo;</li>
        <li>Definir a quantidade de silos;</li>
        <li>Definir a quantidade de ventiladores (Se houver controle da aeração);</li>
      </ul>
      <el-row>
        <el-col :span="12" align="left" style="margin-top: 15px; padding-left: 20px;">
          <el-checkbox style="text-align: left!important;" label="Não apresentar mais essa janela" @change="setNaoMostrarAviso"/>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="primary" @click="formAvisoVisible = false">Ok</el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- Modal Contato -->
    <el-dialog title="Contato" :visible.sync="formContatoVisible">
      <el-form ref="form" :model="contato" :rules="rulesContato" label-width="120px">
        <el-form-item label="Nome" prop="nome">
          <el-input v-model="contato.nome"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="contato.email"></el-input>
        </el-form-item>
        <el-form-item label="Telefone" prop="telefone">
          <el-input v-model="contato.telefone" maxlength="16"></el-input>
        </el-form-item>
        <el-form-item label="Cargo" prop="cargo">
          <el-input v-model="contato.cargo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="formContatoVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="salvarContato">Salvar</el-button>
      </span>
    </el-dialog>

    <!-- Modal cliente -->
    <el-dialog title="Cliente" :visible.sync="formClienteVisible">
      <el-form ref="form" :model="cliente" :rules="rulesCliente" label-width="120px">
        <el-form-item label="Nome" prop="nome">
          <el-input v-model="cliente.nome"></el-input>
        </el-form-item>
        <el-form-item label="CPF/CNPJ" prop="cpfcnpj">
          <el-input v-model="cliente.cpfcnpj" maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="Logradouro" prop="logradouro">
          <el-input v-model="cliente.logradouro"></el-input>
        </el-form-item>
        <el-form-item label="Bairro" prop="bairro">
          <el-input v-model="cliente.bairro"></el-input>
        </el-form-item>
        <el-form-item label="Cidade" prop="cidade">
          <el-input v-model="cliente.cidade"></el-input>
        </el-form-item>
        <el-form-item label="Estado" prop="estado">
          <el-input 
            v-model="cliente.estado" 
            maxlength="2" 
            @input="cliente.estado = cliente.estado.toUpperCase().slice(0, 2)">
          </el-input>
        </el-form-item>
        <el-form-item label="CEP" prop="cep">
          <el-input v-model="cliente.cep" maxlength="10"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="cliente.email"></el-input>
        </el-form-item>
        <el-form-item label="Telefone" prop="telefone">
          <el-input v-model="cliente.telefone" maxlength="15"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="formClienteVisible = false">Cancelar</el-button>
        <el-button type="primary" @click="salvarCliente">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import FuncoesUteis from '../../plugins/FuncoesUteis';

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      clientes: [],
      listas: [],
      produtos: [],
      precos: [],
      contatos: [],
      cliente: {},
      contato: {},
      permissao: {},
      representante: {},
      edicaoOrcamento: false,
      user_id: null,
      orcamento: {
        id: null, 
        orcamento_base: '0000.00.0000',
        orcamento_versao: 1,
        orcamento_historico_revisao: 'Emissão Inicial',
        cliente_id: null,
        contato_id: null,
        produto_lista_id: null,
        ncm: '90.32.89.82',
        ampliacao: false,
        tipo_termometria: 0,
        ventiladores: 0,
        ventiladores_possiveis: 0,
        itens: [],
        outros: 0,
        subtotal: 0,
        total_sem_ipi: 0,
        aliquota_icms: 0.12,
        aliquota_pis_cofins: 0.0925,
        aliquota_ipi: 0.15,
        reducao_ipi: 0.35,
        aliquota_ipi_reduzida: 0,
        ipi: 0,
        total_com_ipi: 0,
        validade: null,
        observacao: '',
      },
      loading: false,
      formClienteVisible: false,
      formContatoVisible: false,
      formAvisoVisible: false,
      fabricante: null,
      clienteSelecionado: null,
      centralTermoB: null,
      estacaoMetereologica: null,
      mav4A: null,
      mav8A: null,
      rulesCliente: {
        nome: [
          { required: true, message: 'Por favor, insira o nome', trigger: 'blur' },
          { min: 3, message: 'O nome deve ter pelo menos 3 caracteres', trigger: 'blur' }
        ],
        email: [{ type: 'email', message: 'Email inválido', trigger: 'blur' }],
      },
      rulesContato: {
        nome: [
          { required: true, message: 'Por favor, insira o nome', trigger: 'blur' },
          { min: 3, message: 'O nome deve ter pelo menos 3 caracteres', trigger: 'blur' }
        ],
        email: [{ type: 'email', message: 'Email inválido', trigger: 'blur' }],
      },
    };
  },
  async mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.fabricante = localStorage.getItem('fabricante_nome');
    
    this.formAvisoVisible = !this.mostrarAviso();

    // Garantir que todas as chamadas assíncronas sejam concluídas
    await this.buscarClientes();
    await this.buscarProdutos();
    await this.buscarListaProduto();
    await this.buscarRepresentante();
    await this.buscarContatos();
    await this.buscarVendedores();

    // Determina a ação com base na rota
    const routeName = this.$route.name;
    const id = this.$route.params.id;

    if (routeName === 'termometria-orcamento-duplicar' && id) {
      this.edicaoOrcamento = true;
      await this.buscarOrcamento(id, true);
    } else if (routeName === 'termometria-orcamento-criar' && id) {
      await this.buscarOrcamento(id, false);
    } else {
      this.verificaTipoTermometria();
      await this.gerarNumeroOrcamento();
    }

  },
  watch: {
    'orcamento.ventiladores': {
      handler() {
        this.calcularTotais();
      },
    },
    'orcamento.ampliacao': {
      handler() {
        this.calcularTotais();
      },
    },
  },
  methods: {


    async buscarClientes(user_id) {
      try {
        this.loading = true;
        // console.log("usuário:", user_id);
        const response = await axios.get(url + '/termometria-cliente/'+user_id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.clientes = response.data;
          // console.log("Clientes carregados:", this.clientes);
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Clientes: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    async buscarRepresentante() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/representante/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.representante = response.data;
          if (!this.representante.id){
            this.$message.error('Cadastre um representente em Contatos.');
            this.$router.push("/termometria");
            return
          }
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Fabricante: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarContatos() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/fabricante-contato/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.contatos = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Contatos: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarVendedores() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/vendedores-recursivo/', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.vendedores = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Vendedores: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarListaProduto() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/termometria-produto-lista', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.listas = response.data;
          this.buscarProdutosPorCodNbr();
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Lista de Produtos: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarProdutos() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/termometria-produto', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.produtos = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Produtos: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    async buscarPrecos() {
      try {
        this.loading = true;
        if (this.orcamento.produto_lista_id) {
          const response = await axios.get(`${url}/termometria-produto-lista-preco/${this.orcamento.produto_lista_id}`, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          });
          if (response.data.status === "Token is Expired") {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
          } else {
            this.precos = response.data;
            this.orcamento.validade = this.listas.find(lista => lista.id === this.orcamento.produto_lista_id).data_validade;
            this.orcamento.itens.forEach((item, index) => this.updatePreco(index));
            this.calcularTotais();
          }
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Preço do Produto: ' + error.message);
      } finally {
        this.loading = false;
      }
    },


    buscarProdutosPorCodNbr() {
      this.centralTermoB = this.produtos.find(p => p.tag === 'CENTRALTB')?.id || null;
      this.estacaoMetereologica = this.produtos.find(p => p.tag === 'EMETER')?.id || null;
      this.mav4A = this.produtos.find(p => p.tag === 'MAV4')?.id || null;
      this.mav8A = this.produtos.find(p => p.tag === 'MAV8')?.id || null;
    },


    atualizarItensOrcamento() {
      const novosItens = [];
      if (!this.orcamento.ampliacao) {
        // Central Termo B
        const temItemNaoEspecial = this.orcamento.itens.some(item => 
          ![this.centralTermoB, this.estacaoMetereologica, this.mav4A, this.mav8A].includes(item.produto_id)
        );
        if (temItemNaoEspecial && this.centralTermoB) {
          novosItens.push({
            ordem: 1,
            produto_id: this.centralTermoB,
            quantidade: 1,
            preco: this.precos.find(p => p.produto_id === this.centralTermoB)?.valor || 0,
            cod_nbr: this.produtos.find(p => p.id === this.centralTermoB)?.cod_nbr || '',
            cod_fabricante: this.produtos.find(p => p.id === this.centralTermoB)?.cod_fabricante || ''
          });
        }

        // Estação Meteorológica
        if (this.orcamento.ventiladores >= 1 && this.estacaoMetereologica) {
          novosItens.push({
            ordem: 2,
            produto_id: this.estacaoMetereologica,
            quantidade: 1,
            preco: this.precos.find(p => p.produto_id === this.estacaoMetereologica)?.valor || 0,
            cod_nbr: this.produtos.find(p => p.id === this.estacaoMetereologica)?.cod_nbr || '',
            cod_fabricante: this.produtos.find(p => p.id === this.estacaoMetereologica)?.cod_fabricante || ''
          });
        }

        // MAVs
        if (this.orcamento.ventiladores > 0) {
          const restoDivisao = this.orcamento.ventiladores % 8;
          let qtdMav8A = 0
          if (restoDivisao<5){
            qtdMav8A = Math.floor(this.orcamento.ventiladores / 8);
          } else {
            qtdMav8A = Math.ceil(this.orcamento.ventiladores / 8);
          }
          if (qtdMav8A > 0 && this.mav8A) {
            novosItens.push({
              ordem: 3,
              produto_id: this.mav8A,
              quantidade: qtdMav8A,
              preco: this.precos.find(p => p.produto_id === this.mav8A)?.valor || 0,
              cod_nbr: this.produtos.find(p => p.id === this.mav8A)?.cod_nbr || '',
              cod_fabricante: this.produtos.find(p => p.id === this.mav8A)?.cod_fabricante || ''
            });
          }
          if (restoDivisao > 0 && restoDivisao <= 4 && this.mav4A) {
            novosItens.push({
              ordem: 4,
              produto_id: this.mav4A,
              quantidade: 1,
              preco: this.precos.find(p => p.produto_id === this.mav4A)?.valor || 0,
              cod_nbr: this.produtos.find(p => p.id === this.mav4A)?.cod_nbr || '',
              cod_fabricante: this.produtos.find(p => p.id === this.mav4A)?.cod_fabricante || ''
            });
          }
        }

      // Manter itens não especiais
      this.orcamento.itens.forEach(item => {
        if (![this.centralTermoB, this.estacaoMetereologica, this.mav4A, this.mav8A].includes(item.produto_id)) {
          novosItens.push({ ...item });
        }
      });
        
      } else {
        // Se for ampliação, manter todos os itens
        this.orcamento.itens.forEach(item => {
            novosItens.push({ ...item });
        });
      }

      // Atualizar itens reativamente
      this.$set(this.orcamento, 'itens', novosItens.sort((a, b) => a.ordem - b.ordem));
    },


    updatePreco(index) {
      const item = this.orcamento.itens[index];
      const preco = this.precos.find(preco => preco.produto_id === item.produto_id);
      item.preco = preco ? preco.valor : 0;
      this.ajustaDadosProduto(index);
      this.calcularTotais();
    },


    addItem() {
      this.orcamento.itens.push({ ordem: 100, produto_id: '', cod_nbr: '', cod_fabricante: '', quantidade: 1, preco: 0 });
    },


    formatarDataParaISO(data) {
      const partes = data.split('/');
      if (partes.length !== 3) return '';

      let ano = partes[2];
      let mes = partes[1];
      let dia = partes[0];

      if (ano.length === 2) {
        ano = '20' + ano;
      }

      return `${ano}-${mes}-${dia}`;
    },


    ajustaDadosProduto(index) {
      const item = this.orcamento.itens[index];
      const produto = this.produtos.find(produto => produto.id === item.produto_id);
      if (produto) {
        item.cod_nbr = produto.cod_nbr;
        item.cod_fabricante = produto.cod_fabricante;
        if (produto.id === this.centralTermoB) {
          item.ordem = 1;
        } else if (produto.id === this.estacaoMetereologica) {
          item.ordem = 2;
        } else if (produto.id === this.mav8A) {
          item.ordem = 3;
        } else if (produto.id === this.mav4A) {
          item.ordem = 4;
        } else {
          item.ordem = 10;
        }
      }
    },


    removeItem(index) {
      this.orcamento.itens.splice(index, 1);
      this.calcularTotais();
    },


    verificaTipoTermometria() {
      const temMav = this.orcamento.itens.find(p => (p.produto_id === this.mav4A || p.produto_id === this.mav8A));
      this.orcamento.tipo_termometria = temMav ? 1 : 0;
    },


    totalPossivelMotores() {
      const totalMotoresMav4A = this.orcamento.itens.find(p => p.produto_id === this.mav4A)?.quantidade || 0;
      const totalMotoresMav8A = this.orcamento.itens.find(p => p.produto_id === this.mav8A)?.quantidade || 0;
      this.orcamento.ventiladores_possiveis = (totalMotoresMav4A * 4) + (totalMotoresMav8A * 8);
    },


    calcularTotais: debounce(function () {
      if (!this.orcamento.produto_lista_id) {
        this.$message.warning("Selecione uma Lista de Preço de Produtos!");
        return;
      }
      this.atualizarItensOrcamento();
      this.totalPossivelMotores();
      this.verificaTipoTermometria();
      this.orcamento.aliquota_ipi_reduzida = this.orcamento.aliquota_ipi * (1 - this.orcamento.reducao_ipi);
      this.orcamento.subtotal = this.orcamento.itens.reduce((acc, item) => acc + item.quantidade * item.preco, 0);
      this.orcamento.ipi = (this.orcamento.subtotal + this.orcamento.outros) * this.orcamento.aliquota_ipi_reduzida;
      this.orcamento.total_sem_ipi = this.orcamento.subtotal + this.orcamento.outros;
      this.orcamento.total_com_ipi = this.orcamento.subtotal + this.orcamento.outros + this.orcamento.ipi;
    }, 300),

    
    mostrarDadosCliente() {
      this.clienteSelecionado = this.clientes.find(c => c.id === this.orcamento.cliente_id) || null;
    },


    async submitOrcamento() {
      this.$refs.formOrcamento.validate(async valid => {
        if (valid) {
          try {
            this.loading = true;
            const payload = {
              id: this.orcamento.id,
              cliente_id: this.orcamento.cliente_id,
              contato_id: this.orcamento.contato_id,
              produto_lista_id: this.orcamento.produto_lista_id,
              orcamento_base: this.orcamento.orcamento_base,
              orcamento_cliente_sge: this.orcamento.orcamento_cliente_sge,
              orcamento_versao: this.orcamento.orcamento_versao,
              orcamento_historico_revisao: this.orcamento.orcamento_historico_revisao,
              ncm: this.orcamento.ncm,
              ampliacao: this.orcamento.ampliacao,
              tipo_termometria: this.orcamento.tipo_termometria,
              ventiladores: this.orcamento.ventiladores,
              ventiladores_possiveis: this.orcamento.ventiladores_possiveis,
              itens: this.orcamento.itens.map(item => ({
                id: item.id,
                produto_id: item.produto_id,
                quantidade: item.quantidade,
                valor: item.preco,
              })),
              outros: this.orcamento.outros,
              subtotal: this.orcamento.subtotal,
              total_sem_ipi: this.orcamento.total_sem_ipi,
              aliquota_icms: this.orcamento.aliquota_icms,
              aliquota_pis_cofins: this.orcamento.aliquota_pis_cofins,
              aliquota_ipi: this.orcamento.aliquota_ipi,
              reducao_ipi: this.orcamento.reducao_ipi,
              aliquota_ipi_reduzida: this.orcamento.aliquota_ipi_reduzida,
              ipi: this.orcamento.ipi,
              total_com_ipi: this.orcamento.total_com_ipi,
              total: this.orcamento.total,
              validade: this.formatarDataParaISO(this.orcamento.validade),
              observacao: this.orcamento.observacao,
            };
            const response = await axios.post(url + '/termometria-orcamento-cadastrar-2', payload, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            });
            if (response.data.status === "Token is Expired") {
              await this.$store.dispatch("logout");
              this.$router.push("/login");
            } else {
              this.$message.success(response.data.message);
              this.$router.push('/termometria');
            }
          } catch (error) {
            this.$message.error('Erro ao salvar orçamento: ' + (error.response?.data?.message || error.message));
          } finally {
            this.loading = false;
          }
        } else {
          this.$message.error('Por favor, corrija os erros no formulário.');
        }
      });
    },


    async buscarOrcamento(id, isDuplicar = false) {
      try {
        this.loading = true;
        const response = await axios.get(url + '/termometria-orcamento-cadastrar/' + id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          const payload = response.data;
          this.user_id = payload.users_id;
          // console.log('user_id', this.user_id);
          await this.buscarClientes(this.user_id);
          await this.buscarProdutos();
          await this.buscarListaProduto();

          if (isDuplicar) {
            const response = await axios.get(url + '/termometria-orcamento-versao-proxima/' + payload.orcamento_cliente_sge, {
              headers: { Authorization: "Bearer " + this.$store.state.token },
            });
            const novo_orcamento_versao = response.data.proxima_versao;
            this.orcamento = {
              ...payload,
              id: null,
              orcamento_historico_revisao: '',
              orcamento_versao: novo_orcamento_versao,
              ampliacao: payload.ampliacao ? true : false,
            };
          } else {
            this.orcamento = {
              ...payload,
              ampliacao: payload.ampliacao ? true : false,
            };
          }

          this.fabricante = localStorage.getItem('fabricante_nome');
          this.formAvisoVisible = !this.mostrarAviso();
          this.verificaTipoTermometria();
          await this.buscarPrecos();
          this.mostrarDadosCliente();
          this.calcularTotais();
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.$message.error("Orçamento não encontrado ou você não tem permissão.");
          this.$router.push("/termometria");
        } else {
          this.$message.error('Erro ao buscar orçamento: ' + (error.response?.data?.message || error.message));
        }
      } finally {
        this.loading = false;
      }
    },


    getProduto(produtoId) {
      return this.produtos.find(produto => produto.id === produtoId) || {};
    },


    async salvarContato() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response;
            // console.log("Contato a salvar:", this.contato);
            if (this.contato.id) {
              response = await axios.put(url + '/fabricante-contato/' + this.contato.id, this.contato, {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              });
              this.$message.success('Contato atualizado com sucesso!');
            } else {
              response = await axios.post(url + '/fabricante-contato', this.contato, {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              });
              this.$message.success('Contato salvo com sucesso!');
            }
            await this.buscarContatos();
            this.orcamento.contato_id = response.data.id;
            this.formContatoVisible = false;
          } catch (error) {
            this.$message.error('Erro ao salvar/atualizar contato: ' + error.message);
          }
        } else {
          this.$message.error('Por favor, corrija os erros no formulário.');
        }
      });
    },


    async salvarCliente() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response;
            if (this.cliente.id) {
              response = await axios.put(url + '/termometria-cliente/' + this.cliente.id, this.cliente, {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              });
              this.$message.success('Cliente atualizado com sucesso!');
            } else {
              response = await axios.post(url + '/termometria-cliente', this.cliente, {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              });
              this.$message.success('Cliente salvo com sucesso!');
            }
            await this.buscarClientes();
            this.orcamento.cliente_id = response.data.id;
            this.mostrarDadosCliente();
            this.formClienteVisible = false;
          } catch (error) {
            this.$message.error('Erro ao salvar/atualizar cliente: ' + error.message);
          }
        } else {
          this.$message.error('Por favor, corrija os erros no formulário.');
        }
      });
    },


    adicionarContato() {
      this.contato = {
        id: null,
        fabricante_id: 0,
        nome: "",
        email: "",
        telefone: "",
        cargo: "",
      };
      this.formContatoVisible = true;
    },


    editarContato(id) {
      const contatoEncontrado = this.contatos.find(contato => contato.id === id);
      this.contato = { ...contatoEncontrado };
      this.formContatoVisible = true;
    },


    adicionarCliente() {
      this.cliente = {
        id: null,
        nome: "",
        cpfcnpj: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
        email: "",
        telefone: "",
      };
      this.formClienteVisible = true;
    },


    editarCliente(id) {
      const clienteEncontrado = this.clientes.find(cliente => cliente.id === id);
      this.cliente = { ...clienteEncontrado };
      this.formClienteVisible = true;
    },


    async gerarNumeroOrcamento() {
      try {
        const sge_fabricante = String(localStorage.getItem('ultimo_fabricante')).padStart(4, '0');
        const ano = new Date().getFullYear().toString().slice(-2);
        const response = await axios.get(url + '/termometria-orcamento-proximo-id', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        const proximo_orcamento_id = response.data.proximo_id;
        const sequencial = String(proximo_orcamento_id).padStart(4, '0');
        this.orcamento.orcamento_base = sge_fabricante + '.' + ano + '.' + sequencial;
        this.orcamento.orcamento_versao = 1;
        this.orcamento.orcamento_cliente_sge = proximo_orcamento_id;
      } catch (error) {
        this.$message.error('Erro ao obter o próximo ID do orçamento: ' + error.message);
      }        
    },


    setNaoMostrarAviso() {
      localStorage.setItem('mostrar_aviso_termometria', 'Não');
    },


    mostrarAviso() {
      return localStorage.getItem('mostrar_aviso_termometria') === 'Não';
    },


    gerarRelatorioLatex() {
      // // instalar: npm install file-saver
      // // Dados do orçamento
      // const cliente = this.clienteSelecionado || { nome: 'Não especificado', logradouro: '', bairro: '', cidade: '', estado: '', cep: '', telefone: '', email: '' };
      // const numeroOrcamento = this.orcamento.orcamento_base;
      // const dataAtual = new Date().toLocaleDateString('pt-BR');
      // const itens = this.orcamento.itens.map(item => {
      //   const produto = this.getProduto(item.produto_id);
      //   return {
      //     nome: produto.nome || 'Produto não especificado',
      //     cod_nbr: produto.cod_nbr || '',
      //     quantidade: item.quantidade,
      //     preco: item.preco,
      //     subtotal: item.quantidade * item.preco,
      //   };
      // });
      // 
      // // Template LaTeX
      // const latexContent = `
      //   \\documentclass[a4paper,10pt]{article}
      //   \\usepackage[utf8]{inputenc}
      //   \\usepackage[brazil]{babel}
      //   \\usepackage{geometry}
      //   \\geometry{margin=2cm}
      //   \\usepackage{booktabs}
      //   \\usepackage{longtable}
      //   \\usepackage{eurosym}
      //   \\usepackage{siunitx}
      //   \\sisetup{
      //     output-decimal-marker={,},
      //     group-separator={.},
      //     group-minimum-digits=4
      //   }
      // 
      //   \\title{Orçamento Termometria - ${numeroOrcamento}}
      //   \\author{NBRtec}
      //   \\date{${dataAtual}}
      //
      //   \\begin{document}
      // 
      //   \\maketitle
      // 
      //   \\section*{Dados do Cliente}
      //   \\begin{tabular}{ll}
      //     Nome: & ${cliente.nome} \\\\
      //     Endereço: & ${cliente.logradouro}, ${cliente.bairro}, ${cliente.cidade} - ${cliente.estado}, CEP: ${cliente.cep} \\\\
      //     Telefone: & ${cliente.telefone} \\\\
      //     Email: & ${cliente.email} \\\\
      //   \\end{tabular}
      // 
      //   \\section*{Detalhes do Orçamento}
      //   \\textbf{Número do Orçamento:} ${numeroOrcamento} \\\\
      //   \\textbf{Ampliação:} ${this.orcamento.ampliacao ? 'Sim' : 'Não'} \\\\
      //   \\textbf{Ventiladores:} ${this.orcamento.ventiladores} \\\\
      //   \\textbf{Observação:} ${this.orcamento.observacao || 'Nenhuma observação'} \\\\
      // 
      //   \\section*{Itens do Orçamento}
      //     \\toprule
      //   \\begin{tabular}{lr}
      //     \\textbf{Produto} & \\textbf{NBRtec} & \\textbf{Quantidade} & \\textbf{Subtotal (R\\$)} \\\\
      //     \\midrule
      //     ${itens.map(item => `${item.nome} & ${item.cod_nbr} & ${item.quantidade} & \\num{${item.subtotal.toFixed(2)}}`).join(' \\\\ ')}
      //     \\bottomrule
      //   \\end{tabular}
      //
      //   \\section*{Totais}
      //   \\begin{tabular}{lr}
      //     Subtotal de Produtos: & \\euro\\ \\num{${this.orcamento.subtotal.toFixed(2)}} \\\\
      //     Outros Custos: & \\euro\\ \\num{${this.orcamento.outros.toFixed(2)}} \\\\
      //     Total sem IPI: & \\euro\\ \\num{${this.orcamento.total_sem_ipi.toFixed(2)}} \\\\
      //     IPI (${(this.orcamento.aliquota_ipi_reduzida * 100).toFixed(2)}\\%): & \\euro\\ \\num{${this.orcamento.ipi.toFixed(2)}} \\\\
      //     \\textbf{Total com IPI:} & \\textbf{\\euro\\ \\num{${this.orcamento.total_com_ipi.toFixed(2)}}} \\\\
      //   \\end{tabular}
      //
      //   \\section*{Observações Gerais}
      //   \\begin{itemize}
      //     \\item Valores sem mão de obra para instalação, caso necessário deverá ser cotado à parte.
      //     \\item Frete na modalidade FOB-PANAMBI/RS;
      //     ${this.orcamento.reducao_ipi > 0 ? `\\item Redução da alíquota de IPI em ${this.orcamento.reducao_ipi * 100}\\%` : ''}
      //   \\end{itemize}
      // 
      //   \\end{document}
      // `;
      // 
      //   console.log('latexContent', latexContent)
      //   // Criar o arquivo e baixar
      //   //const blob = new Blob([latexContent], { type: 'text/plain;charset=utf-8' });
      //   //saveAs(blob, `Orcamento_${numeroOrcamento}.tex`);
      //   this.$message.success('Relatório LaTeX gerado com sucesso! Verifique seus downloads.');
    },


    recebeOrcamento() {
      const id = 5;
      if (id != null) {
        this.buscarOrcamento(id);
      } else {
        this.orcamento = {
          id: null, 
          orcamento_base: '0000.00.0000',
          orcamento_versao: 1,
          orcamento_historico_revisao: 'Emissão Inicial',
          cliente_id: null,
          contato_id: null,
          produto_lista_id: null,
          ncm: '90.32.89.82',
          ampliacao: false,
          tipo_termometria: 0,
          ventiladores: 0,
          ventiladores_possiveis: 0,
          itens: [],
          outros: 0,
          subtotal: 0,
          total_sem_ipi: 0,
          aliquota_icms: 0.12,
          aliquota_pis_cofins: 0.0925,
          aliquota_ipi: 0.15,
          reducao_ipi: 0.35,
          aliquota_ipi_reduzida: 0,
          ipi: 0,
          total_com_ipi: 0,
          validade: null,
          observacao: '',
        };
      }
      this.$message.info('Funcionalidade de receber orçamento ainda sendo implementada.');
    },
  },


  filters: {
    currency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    },
  },


};
</script>

<style scoped>
.container {
  text-align: left!important;
  padding-bottom: 50px;
  min-width: 1260px;
}
.cliente-info {
  margin-bottom: 20px;
}
.itens {
  margin-bottom: 20px;
}
.totais {
  margin-top: 20px;
}
.small-input-number {
  width: 100%;
}
.select-data {
  width: 100%;
}
.select-data-2 {
  width: 83%;
}
</style>
